import { render, staticRenderFns } from "./SpaceMediumLight.vue?vue&type=template&id=2c360c83&"
import script from "./SpaceMediumLight.vue?vue&type=script&lang=js&"
export * from "./SpaceMediumLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports